

import {headers} from '@utils/utils';
const useCategoriaStore = defineStore('categoria', () => {

  // state
  const categoria = ref({
    id:null,
    nombre:null,
    descripcion:null,
    icono:null,
    categoria_id:null,
  });

  const categorias = ref([]);


  // getters
  const draft = computed(() => clone(categoria.value));

  // methods
  const setCategoria = (cat) => {
    console.log('Recibido categoria:', cat);
    categoria.value = cat;
  };

  const setCategorias = (cats) => {
    categorias.value = cats;
  };


  const clear = () => {
    categoria.value = {
      id: null,
      nombre: null,
      descripcion: null,
      icono: null,
      categoria_id: null,
    };
  };



  // methods actions
  const fetch = async (cat_id) => {
    try {
      const response = await axios.get(`/api/categorias/${cat_id}/fetch-data`);
      const data = response.data;
    
      return data;
    } catch (error) {
       console.log("Error fetching category:", error);    
    }
  };


  const fetchData = (params) => {
    return new Promise((resolve,reject) => {
      axios.post(`/api/categorias/fetch-data`,params)
      .then(({data}) => resolve(data))
      .catch((e) => reject(e)); 
    })
  };

  const guardar = (datos) => {
    let formData = new FormData();
    Object.keys(datos).forEach(key => {
      formData.append(key,datos[key]);
    });
    return new Promise((resolve, reject) => {
       if(datos.id){
          formData.append('_method', 'PUT');
          axios.post(`/api/categorias/${datos.id}`,formData,{headers})
          .then(({data}) => {
            resolve(data);
          })
          .catch(e => reject(e))
        }else{
          axios.post(`/api/categorias`,formData,{headers})
          .then(({data}) => {
            resolve(data);
          })
          .catch(e => reject(e));
        }
    });
   
  };

  const eliminar = (cat_id) => {

    return new Promise((resolve, reject) => {
      axios.delete(`/api/categorias/${cat_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchListSelect = async () => {
    try {
        const response = await axios.get(`/api/categorias/list-select`);
        return response.data;
    } catch (error) {
        console.log("Error fetching categories for select:", error);
    }
  }

  const getLigthTree  = () => {
    return new Promise((resolve, reject) => {

        axios.get(`/api/categorias/listado/ligth-tree`)
        .then(({data}) => {
          if(data.length){
            setCategorias(data);
          }
          resolve(data);

        }).catch(e => reject(e));

    });
  }


  return {
    // state,
    categoria,
    categorias,
    // methods
    setCategoria,
    setCategorias,
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    fetchListSelect,
    getLigthTree,
  };
});


export default useCategoriaStore;